var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.429 13.5q-.607 0-1.018-.431A1.5 1.5 0 0 1 2 12q0-.637.41-1.069A1.35 1.35 0 0 1 3.43 10.5H20.57q.607 0 1.018.431Q22 11.363 22 12t-.41 1.069a1.35 1.35 0 0 1-1.019.431z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusOutline);
export default __webpack_public_path__ + "static/media/minus_outline.c7983b4d76b7da65fa101f702512df70.svg";
export { ForwardRef as ReactComponent };